import type { MetadataItem } from '../tool-config-types';

type FindingInput = {
  findings?: Array<{ severity?: string }>;
  finding?: { severity?: string };
  severity?: string;
  title?: string;
};

const isFindingInput = (input: unknown): input is FindingInput => {
  return typeof input === 'object' && input !== null;
};

/**
 * Extract metadata for finding tools
 * Shows: severity, count of findings
 */
export const extractFindingMetadata = ({
  input,
}: {
  input: unknown;
  output?: unknown;
}): MetadataItem[] => {
  const metadata: MetadataItem[] = [];

  if (!isFindingInput(input)) return metadata;

  // Get findings array or single finding
  let findings: Array<{ severity?: string }> = [];
  if (Array.isArray(input.findings)) {
    findings = input.findings;
  } else if (input.finding && typeof input.finding === 'object') {
    findings = [input.finding];
  } else if (input.severity || input.title) {
    findings = [input];
  }

  // Show count if multiple
  if (findings.length > 1) {
    metadata.push({ label: 'Count', value: `${findings.length} findings` });
  }

  // Show severity of first finding (or the single finding)
  const severity = findings[0]?.severity;
  if (severity) {
    metadata.push({ label: 'Severity', value: severity });
  }

  return metadata;
};
